import * as React from 'react';
import './LimitReached.css';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import { Link } from 'react-router-dom';

export interface LimitReachedComponentProps {
  amountInvestedLastYear: number;
  modalRef?: Modal;
  reachedType: number;
}

const LimitReachedComponent = (props: LimitReachedComponentProps) => {
  return (
    <div className="modal-content limit-reached-component">
      <h4 className="title">Has llegado a tu límite de inversión</h4>
      {props.reachedType === 1 ?
        <div>
          <p>
            Como inversor&nbsp;
            <span className="not-acredited-highlighting">"No acreditado"</span>&nbsp;no
            puedes invertir más de 10.000 € en un periodo de 12 meses.
            <br/>Actualmente has invertido {props.amountInvestedLastYear.toLocaleString('es-ES')} € en los últimos
            meses.
          </p>
          < p>¿Quiéres invertir más de 10.000 €? Acredítate</p>
        </div> :
          <div>
              <p>
                  Como inversor&nbsp;
                  <span className="not-acredited-highlighting">"No acreditado"</span>&nbsp;no
                  puedes invertir más de 3.000 € en una misma operación.
                  <br/>
              </p>
            < p>¿Quiéres invertir más de 3.000 € por operación? Acredítate</p>
          </div>

      }
      <div className="action-buttons">
        <button
          className="btn btn-primary"
          onClick={() => props.modalRef!.modal('hide')}
        >
          Volver atrás
        </button>
        <Link
          to="/mi-cuenta/tipo-de-inversor"
          onClick={() => props.modalRef!.modal('hide')}
        >
          <button className="btn btn-secondary">Acreditarme</button>
        </Link>
      </div>
    </div>
  );
};

export default LimitReachedComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/limit-reached/LimitReached.component.tsx